import axios from 'axios'
import { config, configMultipart, url } from '../../index'
import { clearUserHtml } from '@/utils/utils'
import router
  from '@/router'
import { createItem, deleteItem, updateItem } from '@/api/defaultApi'

const state = () => ({
  task: {},
  messageArea: {
    updatedId: null,
    message: '',
    destination: {
      id: null,
      name: '',
      quote: ''
    },
    attachment: {
      linkTooltip: {
        active: false,
        text: '',
        url: '',
        textValid: {},
        urlValid: {}
      },
      tagTooltip: {
        active: false,
        text: '',
        valid: {}
      },
      files: [],
      tags: [],
      filesToRemove: []
    },
    valid: {}
  },
  updateModal: {
    active: false,
    isLoading: false,
    task_id: null,
    validation: {
      name: {},
      description: {},
      assignees: {}
    },
    name: '',
    description: '',
    is_important: false,
    attachment: {
      linkTooltip: {
        active: false,
        text: '',
        url: '',
        textValid: {},
        urlValid: {}
      },
      tagTooltip: {
        active: false,
        text: '',
        valid: {}
      },
      files: [],
      tags: [],
      filesToRemove: []
    },
    date_deadline: '',
    parentTask: { id: 0, name: '' },
    column: { id: null, name: '' },
    assignees: [],
    watchers: []
  },
  isLoading: true
})

const getters = {
  getTaskInfo: state => state.task,
  getTaskInfoComments: state => state.task.comments,
  getTaskInfoMessageArea: state => state.messageArea,
  getTaskInfoUpdateModal: state => state.updateModal,
  getTaskInfoIsLoading: state => state.isLoading
}

const mutations = {
  GET_TASK_INFO: (state, task) => {
    state.task = {
      ...task,
      assignees: task.assignees ? task.assignees : [],
      watchers: task.watchers ? task.watchers : [],
      files: task.files ? task.files : [],
      tags: task.tags ? task.tags : [],
      children: task.children ? task.children : [],
      comments: task.comments ? task.comments.map(comment => {
        return { ...comment, isControlsActive: false }
      }) : []
    }
    state.isLoading = false
  },
  GET_TASK_CHILD_INFO: (state, task) => {
    const parseTask = (currentTask, filter) => {
      const result = filter(currentTask)
      const children = currentTask.children ? currentTask.children.slice() : []
      if (children.length !== 0) {
        result.children = result.children.map(e => parseTask(e, filter))
      }
      return result
    }
    const appendChildren = object => {
      if (object.id === task.id) {
        if (object.children_active) {
          return {
            ...object,
            children_active: false,
            children: []
          }
        } else {
          return {
            ...object,
            children_active: true,
            children: task.children ? task.children : []
          }
        }
      } else return object
    }
    state.task = parseTask(state.task, appendChildren)
  },

  // update modal
  SHOW_TASK_INFO_MODAL: (state) => {
    state.updateModal.active = true

    state.updateModal.task_id = state.task.id
    state.updateModal.name = state.task.name
    state.updateModal.is_important = state.task.is_important
    state.updateModal.description = state.task.description
    state.updateModal.attachment.files = state.task.files ? [...state.task.files] : []
    state.updateModal.attachment.tags = state.task.tags ? [...state.task.tags] : []
    // обнуляем файлы на удаление при открытии модалки
    state.updateModal.attachment.filesToRemove = []
    state.updateModal.date_deadline = state.task.before_at
    state.updateModal.column = { id: state.task.column_id, name: state.task.column.name }
    state.updateModal.parentTask = state.task.parent_id ? { id: state.task.parent_id, name: state.task.parent.name } : { id: 0, name: '' }
    state.updateModal.assignees = state.task.assignees.map(user => {
      return { id: user.id, name: `${user.profile.surname ? user.profile.surname : ''} ${user.profile.name} ${user.profile.patronymic ? user.profile.patronymic : ''}` }
    })
    state.updateModal.watchers = state.task.watchers.map(user => {
      return { id: user.id, name: `${user.profile.surname ? user.profile.surname : ''} ${user.profile.name} ${user.profile.patronymic ? user.profile.patronymic : ''}` }
    })
  },
  '[task-info-page] MODAL_REQUEST_START': state => {
    state.updateModal.isLoading = true
  },
  '[task-info-page] MODAL_REQUEST_SUCCESS': state => {
    state.updateModal.isLoading = false
  },
  '[task-info-page] MODAL_REQUEST_FAILURE': state => {
    state.updateModal.isLoading = false
  },
  CLOSE_TASK_INFO_MODAL: (state) => {
    state.updateModal.active = false
  },
  SET_TASK_INFO_UPDATED_TASK_NAME: (state, text) => {
    state.updateModal.name = text
  },
  TOGGLE_TASK_INFO_UPDATED_TASK_IMPORTANCE: (state) => {
    state.updateModal.is_important = !state.updateModal.is_important
  },
  SET_TASK_INFO_UPDATED_TASK_DESCRIPTION: (state, text) => {
    state.updateModal.description = text
  },
  SET_TASK_INFO_UPDATED_TASK_DEADLINE: (state, date) => {
    state.updateModal.date_deadline = date
  },
  SET_TASK_INFO_UPDATED_TASK_PARENT_TASK: (state, task) => {
    state.updateModal.parentTask = task
  },
  SET_TASK_INFO_UPDATED_TASK_COLUMN: (state, column) => {
    state.updateModal.column = column
  },
  ADD_TASK_INFO_UPDATED_TASK_ASSIGNEE: (state, user) => {
    state.updateModal.assignees.push(user)
  },
  REMOVE_TASK_INFO_UPDATED_TASK_ASSIGNEE: (state, user) => {
    state.updateModal.assignees = state.updateModal.assignees.filter(assignee => {
      return assignee.id !== user.id
    })
  },
  ADD_TASK_INFO_UPDATED_TASK_WATCHER: (state, user) => {
    state.updateModal.watchers.push(user)
  },
  REMOVE_TASK_INFO_UPDATED_TASK_WATCHER: (state, user) => {
    state.updateModal.watchers = state.updateModal.watchers.filter(watcher => {
      return watcher.id !== user.id
    })
  },
  TOGGLE_TASK_INFO_MODAL_LINK_TOOLTIP: (state) => {
    state.updateModal.attachment.linkTooltip.active = !state.updateModal.attachment.linkTooltip.active
  },
  CLOSE_TASK_INFO_MODAL_LINK_TOOLTIP: (state) => {
    state.updateModal.attachment.linkTooltip.textValid = {}
    state.updateModal.attachment.linkTooltip.urlValid = {}
    state.updateModal.attachment.linkTooltip.text = ''
    state.updateModal.attachment.linkTooltip.url = ''
    state.updateModal.attachment.linkTooltip.active = false
  },
  SET_TASK_INFO_MODAL_LINK_TEXT: (state, text) => {
    state.updateModal.attachment.linkTooltip.text = text
  },
  SET_TASK_INFO_MODAL_LINK_URL: (state, url) => {
    state.updateModal.attachment.linkTooltip.url = url
  },
  TOGGLE_TASK_INFO_MODAL_TAG_TOOLTIP: (state) => {
    state.updateModal.attachment.tagTooltip.active = !state.updateModal.attachment.tagTooltip.active
  },
  CLOSE_TASK_INFO_MODAL_TAG_TOOLTIP: (state) => {
    state.updateModal.attachment.tagTooltip.textValid = {}
    state.updateModal.attachment.tagTooltip.urlValid = {}
    state.updateModal.attachment.tagTooltip.text = ''
    state.updateModal.attachment.tagTooltip.url = ''
    state.updateModal.attachment.tagTooltip.active = false
  },
  SET_TASK_INFO_MODAL_TAG_TEXT: (state, text) => {
    state.updateModal.attachment.tagTooltip.text = text.replace(/\s/g, '')
  },
  ATTACH_TASK_INFO_MODAL_FILES: (state, files) => {
    const newFiles = Object.values(files)
    state.updateModal.attachment.files = state.updateModal.attachment.files.concat(newFiles)
  },
  REMOVE_TASK_INFO_MODAL_FILE: (state, data) => {
    // по index вырезаем файл из массива отображаемых вложений
    const files = state.updateModal.attachment.files
    files.splice(data.index, 1)
    state.updateModal.attachment.files = files
    // id файлов пушим в массив для последующего удаления с сервера (id есть только если сообщение редактируется)
    if (data.id !== undefined) {
      state.updateModal.attachment.filesToRemove.push(data.id)
    }
  },
  ATTACH_TASK_INFO_MODAL_TAG: (state) => {
    const tagText = state.updateModal.attachment.tagTooltip.text
    state.updateModal.attachment.tags.push(tagText)
  },
  REMOVE_TASK_INFO_MODAL_TAG: (state, index) => {
    const tags = [...state.updateModal.attachment.tags]
    tags.splice(index, 1)
    state.updateModal.attachment.tags = tags
  },
  SET_TASK_INFO_MODAL_LINK_TEXT_VALID: (state, valid) => {
    state.updateModal.attachment.linkTooltip.textValid = valid
  },
  SET_TASK_INFO_MODAL_LINK_URL_VALID: (state, valid) => {
    state.updateModal.attachment.linkTooltip.urlValid = valid
  },
  SET_TASK_INFO_MODAL_TAG_VALID: (state, valid) => {
    state.updateModal.attachment.tagTooltip.valid = valid
  },
  SET_TASK_INFO_UPDATE_MODAL_VALIDATION: (state, valid) => {
    state.updateModal.validation.name = valid.name !== undefined ? { type: 'error', message: valid.name[0] } : {}
    state.updateModal.validation.description = valid.description !== undefined ? { type: 'error', message: valid.description[0] } : {}
    state.updateModal.validation.assignees = valid.assignees !== undefined ? { type: 'error', message: valid.assignees[0] } : {}
  },
  CLEAR_TASK_INFO_MODAL_VALID: (state) => {
    state.updateModal.validation.name = {}
    state.updateModal.validation.description = {}
    state.updateModal.validation.assignees = {}
    state.updateModal.attachment.linkTooltip.textValid = {}
    state.updateModal.attachment.linkTooltip.urlValid = {}
    state.updateModal.attachment.tagTooltip.valid = {}
  },

  // comments
  TOGGLE_TASK_INFO_COMMENTS_ITEM_CONTROLS: (state, itemId) => {
    state.task.comments.forEach((elem) => {
      if (itemId === elem.id) {
        elem.isControlsActive = !elem.isControlsActive
      } else if (itemId !== elem.id) {
        elem.isControlsActive = false
      }
    })
  },
  CLOSE_TASK_INFO_COMMENTS_ITEMS_CONTROLS: (state) => {
    state.task.comments.forEach((elem) => {
      elem.isControlsActive = false
    })
  },
  SET_TASK_INFO_COMMENTS_MESSAGE_VALUE: (state, text) => {
    state.messageArea.message = text
  },
  SET_TASK_INFO_COMMENTS_MESSAGE_REPLY: (state, data) => {
    state.messageArea.destination.id = data.userId
    state.messageArea.destination.name = data.userName
    state.messageArea.destination.quote = data.quote
  },
  REMOVE_TASK_INFO_COMMENTS_MESSAGE_REPLY: (state) => {
    state.messageArea.destination.id = null
    state.messageArea.destination.name = ''
    state.messageArea.destination.quote = ''
  },
  GET_TASK_INFO_COMMENT_TO_UPDATE: (state, message) => {
    state.messageArea.updatedId = message.id

    state.messageArea.message = message.text
    state.messageArea.attachment.files = message.files ? message.files : []
    state.messageArea.attachment.tags = message.tags ? message.tags : []
  },
  TOGGLE_TASK_INFO_COMMENTS_LINK_TOOLTIP: (state) => {
    state.messageArea.attachment.linkTooltip.active = !state.messageArea.attachment.linkTooltip.active
  },
  CLOSE_TASK_INFO_COMMENTS_LINK_TOOLTIP: (state) => {
    state.messageArea.attachment.linkTooltip.textValid = {}
    state.messageArea.attachment.linkTooltip.urlValid = {}
    state.messageArea.attachment.linkTooltip.text = ''
    state.messageArea.attachment.linkTooltip.url = ''
    state.messageArea.attachment.linkTooltip.active = false
  },
  SET_TASK_INFO_COMMENTS_LINK_TEXT: (state, text) => {
    state.messageArea.attachment.linkTooltip.text = text
  },
  SET_TASK_INFO_COMMENTS_LINK_URL: (state, url) => {
    state.messageArea.attachment.linkTooltip.url = url
  },
  TOGGLE_TASK_INFO_COMMENTS_TAG_TOOLTIP: (state) => {
    state.messageArea.attachment.tagTooltip.active = !state.messageArea.attachment.tagTooltip.active
  },
  CLOSE_TASK_INFO_COMMENTS_TAG_TOOLTIP: (state) => {
    state.messageArea.attachment.tagTooltip.textValid = {}
    state.messageArea.attachment.tagTooltip.urlValid = {}
    state.messageArea.attachment.tagTooltip.text = ''
    state.messageArea.attachment.tagTooltip.url = ''
    state.messageArea.attachment.tagTooltip.active = false
  },
  SET_TASK_INFO_COMMENTS_TAG_TEXT: (state, text) => {
    state.messageArea.attachment.tagTooltip.text = text.replace(/\s/g, '')
  },
  ATTACH_TASK_INFO_COMMENTS_FILES: (state, files) => {
    const newFiles = Object.values(files)
    state.messageArea.attachment.files = state.messageArea.attachment.files.concat(newFiles)
  },
  REMOVE_TASK_INFO_COMMENTS_FILE: (state, data) => {
    // по index вырезаем файл из массива отображаемых вложений
    const files = state.messageArea.attachment.files
    files.splice(data.index, 1)
    state.messageArea.attachment.files = files
    // id файлов пушим в массив для последующего удаления с сервера (id есть только если сообщение редактируется)
    if (data.id) {
      state.messageArea.attachment.filesToRemove.push(data.id)
    }
  },
  ATTACH_TASK_INFO_COMMENTS_TAG: (state) => {
    const tagText = state.messageArea.attachment.tagTooltip.text
    state.messageArea.attachment.tags.push(tagText)
  },
  REMOVE_TASK_INFO_COMMENTS_TAG: (state, index) => {
    const tags = [...state.messageArea.attachment.tags]
    tags.splice(index, 1)
    state.messageArea.attachment.tags = tags
  },
  SET_TASK_INFO_COMMENTS_LINK_TEXT_VALID: (state, valid) => {
    state.messageArea.attachment.linkTooltip.textValid = valid
  },
  SET_TASK_INFO_COMMENTS_LINK_URL_VALID: (state, valid) => {
    state.messageArea.attachment.linkTooltip.urlValid = valid
  },
  SET_TASK_INFO_COMMENTS_TAG_VALID: (state, valid) => {
    state.messageArea.attachment.tagTooltip.valid = valid
  },
  SET_TASK_INFO_COMMENTS_MESSAGE_AREA_VALIDATION: (state, valid) => {
    state.messageArea.valid = { type: 'error', message: valid.text[0] }
  },
  CLEAR_TASK_INFO_COMMENTS_VALID: (state) => {
    state.messageArea.attachment.linkTooltip.textValid = {}
    state.messageArea.attachment.linkTooltip.urlValid = {}
    state.messageArea.attachment.tagTooltip.valid = {}
    state.messageArea.valid = {}
  },
  CLEAR_TASK_INFO_COMMENTS_MESSAGE_AREA: (state) => {
    state.messageArea.updatedId = null
    state.messageArea.message = ''
    state.messageArea.destination = { id: null, name: '', quote: '' }
    state.messageArea.attachment.files = []
    state.messageArea.attachment.tags = []
    state.messageArea.attachment.filesToRemove = []
  },
  SET_TASK_INFO_IS_LOADING: (state) => {
    state.isLoading = true
  }
}

const actions = {
  getTaskById ({ commit, state }, data) {
    commit('SET_TASK_INFO_IS_LOADING')
    const expands = 'expand=owner,assignees,watchers,files,column,parent,children,comments'

    axios.get(`${url}/tasks/${data.taskId}?${expands}`, config).then(response => {
      commit('GET_TASK_INFO', response.data.data)
      /* показываем модалку редактирования сразу после загрузки, если переход был из списка задач через "редактировать" */
      if (data.update !== undefined && data.update) {
        commit('SHOW_TASK_INFO_MODAL')
      }
    }).catch(error => {
      console.log('ошибка получения задачи детально', error)
    })
  },
  // экшон для моментального обновления текущей задачи без прелоадера
  getUpdatedCurrentTask ({ commit, state }) {
    const expands = 'expand=owner,assignees,watchers,files,column,parent,children,comments'

    axios.get(`${url}/tasks/${state.task.id}?${expands}`, config).then(response => {
      commit('GET_TASK_INFO', response.data.data)
    }).catch(error => {
      console.log('ошибка получения задачи детально для обновления текущей задачи', error)
    })
  },
  setTaskInfoStageColumn ({ commit, state }, columnId) {
    const id = state.task.id

    const updateData = {
      column_id: columnId
    }

    axios.put(`${url}/tasks/${id}`, updateData, config).then(response => {
      this.dispatch('getUpdatedCurrentTask')
      router.push({ name: 'TaskList' })
    }).catch(error => {
      console.log('ошибка редактирования задачи', error.response.data)
    })
  },
  // развертывание следующих дочерних для дочерней задачи
  toggleTaskInfoChildTaskChildren ({ commit }, taskId) {
    const expands = 'expand=owner,assignees,watchers,column,children,children.column'

    axios.get(`${url}/tasks/${taskId}?${expands}`, config).then(response => {
      commit('GET_TASK_CHILD_INFO', response.data.data)
    }).catch(error => {
      console.log('ошибка получения дочерней задачи детально', error)
    })
  },

  // update modal
  showTaskInfoModal ({ commit }) {
    commit('SHOW_TASK_INFO_MODAL')
  },
  closeTaskInfoModal ({ commit }) {
    commit('CLOSE_TASK_INFO_MODAL')
    commit('CLOSE_TASK_INFO_MODAL_LINK_TOOLTIP')
    commit('CLOSE_TASK_INFO_MODAL_TAG_TOOLTIP')
  },
  clearTaskInfoModalValidation ({ commit }) {
    commit('CLEAR_TASK_INFO_MODAL_VALID')
  },
  setTaskInfoModalName ({ commit }, text) {
    commit('SET_TASK_INFO_UPDATED_TASK_NAME', text)
  },
  toggleTaskInfoModalImportance ({ commit }) {
    commit('TOGGLE_TASK_INFO_UPDATED_TASK_IMPORTANCE')
  },
  setTaskInfoModalDescription ({ commit }, text) {
    commit('SET_TASK_INFO_UPDATED_TASK_DESCRIPTION', text)
  },
  setTaskInfoModalDeadLine ({ commit }, date) {
    commit('SET_TASK_INFO_UPDATED_TASK_DEADLINE', date)
  },
  setTaskInfoModalParentTask ({ commit }, task) {
    commit('SET_TASK_INFO_UPDATED_TASK_PARENT_TASK', task)
  },
  setTaskInfoModalColumn ({ commit }, column) {
    commit('SET_TASK_INFO_UPDATED_TASK_COLUMN', column)
  },
  addTaskInfoModalAssignee ({ commit }, user) {
    commit('ADD_TASK_INFO_UPDATED_TASK_ASSIGNEE', user)
  },
  removeTaskInfoModalAssignee ({ commit }, user) {
    commit('REMOVE_TASK_INFO_UPDATED_TASK_ASSIGNEE', user)
  },
  addTaskInfoModalWatcher ({ commit }, user) {
    commit('ADD_TASK_INFO_UPDATED_TASK_WATCHER', user)
  },
  removeTaskInfoModalWatcher ({ commit }, user) {
    commit('REMOVE_TASK_INFO_UPDATED_TASK_WATCHER', user)
  },
  taskInfoModalToggleLinkTooltip ({ commit }) {
    commit('TOGGLE_TASK_INFO_MODAL_LINK_TOOLTIP')
    commit('CLOSE_TASK_INFO_MODAL_TAG_TOOLTIP')
  },
  taskInfoModalCloseLinkTooltip ({ commit }) {
    commit('CLOSE_TASK_INFO_MODAL_LINK_TOOLTIP')
  },
  taskInfoModalSetLinkText ({ commit }, text) {
    commit('SET_TASK_INFO_MODAL_LINK_TEXT', text)
  },
  taskInfoModalSetLinkUrl ({ commit }, url) {
    commit('SET_TASK_INFO_MODAL_LINK_URL', url)
  },
  taskInfoModalToggleTagTooltip ({ commit }) {
    commit('TOGGLE_TASK_INFO_MODAL_TAG_TOOLTIP')
    commit('CLOSE_TASK_INFO_MODAL_LINK_TOOLTIP')
  },
  taskInfoModalCloseTagTooltip ({ commit }) {
    commit('CLOSE_TASK_INFO_MODAL_TAG_TOOLTIP')
  },
  taskInfoModalSetTagText ({ commit }, text) {
    commit('SET_TASK_INFO_MODAL_TAG_TEXT', text.replace(/\s/g, ''))
  },
  taskInfoModalAttachFiles ({ commit }, files) {
    commit('ATTACH_TASK_INFO_MODAL_FILES', files)
  },
  taskInfoModalRemoveFile ({ commit }, data) {
    commit('REMOVE_TASK_INFO_MODAL_FILE', data)
  },
  taskInfoModalAttachLink ({ commit, state }) {
    const text = state.updateModal.attachment.linkTooltip.text
    const url = state.updateModal.attachment.linkTooltip.url
    if (text && url) {
      commit('CLOSE_TASK_INFO_MODAL_LINK_TOOLTIP')
    } else if (!text) {
      commit('SET_TASK_INFO_MODAL_LINK_TEXT_VALID', { type: 'error', message: 'Поле не заполнено' })
    } else {
      commit('SET_TASK_INFO_MODAL_LINK_URL_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  taskInfoModalAttachTag ({ commit, state }) {
    if (state.updateModal.attachment.tagTooltip.text) {
      commit('ATTACH_TASK_INFO_MODAL_TAG')
      commit('CLOSE_TASK_INFO_MODAL_TAG_TOOLTIP')
    } else {
      commit('SET_TASK_INFO_MODAL_TAG_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  taskInfoModalRemoveTag ({ commit }, index) {
    commit('REMOVE_TASK_INFO_MODAL_TAG', index)
  },
  taskInfoModalClearValidation ({ commit }) {
    commit('CLEAR_TASK_INFO_MODAL_VALID')
  },
  taskInfoModalUpdateTask ({ dispatch, commit, state }) {
    const id = state.updateModal.task_id
    const assignees = state.updateModal.assignees.map(user => {
      return user.id
    })
    const watchers = state.updateModal.watchers.map(user => {
      return user.id
    })
    const formData = new FormData()
    // выбираем только вновь добавленные файлы у которых нет id чтобы не заливать дубли на серв
    const newFiles = state.updateModal.attachment.files.filter(file => {
      return file.id === undefined
    })
    for (let i = 0; i < newFiles.length; ++i) {
      formData.append('files[]', newFiles[i])
    }

    const updateData = {
      name: state.updateModal.name,
      // валидация сервера пишет что значение поля is_important должно быть true/false на деле принимает только 0/1
      is_important: Number(state.updateModal.is_important),
      description: clearUserHtml(state.updateModal.description, false),
      tags: state.updateModal.attachment.tags,
      before_at: state.updateModal.date_deadline,
      parent_id: state.updateModal.parentTask.id,
      column_id: state.updateModal.column.id,
      assignees: assignees,
      watchers: watchers
    }

    const removeAttachedFiles = state.updateModal.attachment.filesToRemove.map(id => {
      return axios.delete(`${url}/files/${id}`, config)
    })
    const attachNewFiles = newFiles.length !== 0 ? axios.post(`${url}/tasks/${id}/upload`, formData, configMultipart) : false
    const updateTaskData = axios.put(`${url}/tasks/${id}`, updateData, config)

    commit('[task-info-page] MODAL_REQUEST_START')
    axios.all([removeAttachedFiles, attachNewFiles, updateTaskData]).then(response => {
      dispatch('[task-info-page] modalRequestSuccess')
    }).catch(error => {
      console.log('ошибка редактирования задачи', error.response)
      commit('[task-info-page] MODAL_REQUEST_FAILURE')
      commit('SET_TASK_INFO_UPDATE_MODAL_VALIDATION', error.response.data.errors)
    })
  },
  '[task-info-page] modalRequestSuccess' ({ dispatch, commit }) {
    commit('[task-info-page] MODAL_REQUEST_SUCCESS')
    commit('CLOSE_TASK_INFO_MODAL')

    dispatch('getUpdatedCurrentTask')
  },

  // comments
  taskInfoCommentsSetMessageValue ({ commit }, text) {
    commit('SET_TASK_INFO_COMMENTS_MESSAGE_VALUE', text)
  },
  toggleTaskInfoCommentsItemControls ({ commit }, itemId) {
    commit('TOGGLE_TASK_INFO_COMMENTS_ITEM_CONTROLS', itemId)
  },
  taskInfoCommentsReplyMessage ({ commit }, data) {
    commit('SET_TASK_INFO_COMMENTS_MESSAGE_REPLY', data)
  },
  taskInfoCommentsUnReplyMessage ({ commit }) {
    commit('REMOVE_TASK_INFO_COMMENTS_MESSAGE_REPLY')
  },
  taskInfoCommentsUpdateMessage ({ commit, state }, itemId) {
    axios.get(`${url}/task-comments/${itemId}`, config).then(response => {
      commit('GET_TASK_INFO_COMMENT_TO_UPDATE', response.data)
      commit('CLOSE_TASK_INFO_COMMENTS_ITEMS_CONTROLS')
    }).catch(error => {
      console.log('ошибка получения комментария для редактирования', error)
    })
  },
  taskInfoCommentsRemoveMessage ({ commit, state }, itemId) {
    axios.delete(`${url}/task-comments/${itemId}`, config).then(response => {
      this.dispatch('getUpdatedCurrentTask')
    }).catch(error => {
      console.log(`ошибка удаления комментария к задаче id:${state.task.id}`, error.response.data.errors)
    })
  },
  taskInfoCommentsToggleLinkTooltip ({ commit }) {
    commit('TOGGLE_TASK_INFO_COMMENTS_LINK_TOOLTIP')
    commit('CLOSE_TASK_INFO_COMMENTS_TAG_TOOLTIP')
  },
  taskInfoCommentsCloseLinkTooltip ({ commit }) {
    commit('CLOSE_TASK_INFO_COMMENTS_LINK_TOOLTIP')
  },
  taskInfoCommentsSetLinkText ({ commit }, text) {
    commit('SET_TASK_INFO_COMMENTS_LINK_TEXT', text)
  },
  taskInfoCommentsSetLinkUrl ({ commit }, url) {
    commit('SET_TASK_INFO_COMMENTS_LINK_URL', url)
  },
  taskInfoCommentsToggleTagTooltip ({ commit }) {
    commit('TOGGLE_TASK_INFO_COMMENTS_TAG_TOOLTIP')
    commit('CLOSE_TASK_INFO_COMMENTS_LINK_TOOLTIP')
  },
  taskInfoCommentsCloseTagTooltip ({ commit }) {
    commit('CLOSE_TASK_INFO_COMMENTS_TAG_TOOLTIP')
  },
  taskInfoCommentsSetTagText ({ commit }, text) {
    commit('SET_TASK_INFO_COMMENTS_TAG_TEXT', text)
  },
  taskInfoCommentsAttachFiles ({ commit }, files) {
    commit('ATTACH_TASK_INFO_COMMENTS_FILES', files)
  },
  taskInfoCommentsRemoveFile ({ commit }, data) {
    commit('REMOVE_TASK_INFO_COMMENTS_FILE', data)
  },
  taskInfoCommentsAttachLink ({ commit, state }) {
    const text = state.messageArea.attachment.linkTooltip.text
    const url = state.messageArea.attachment.linkTooltip.url
    if (text && url) {
      commit('CLOSE_TASK_INFO_COMMENTS_LINK_TOOLTIP')
    } else if (!text) {
      commit('SET_TASK_INFO_COMMENTS_LINK_TEXT_VALID', { type: 'error', message: 'Поле не заполнено' })
    } else {
      commit('SET_TASK_INFO_COMMENTS_LINK_URL_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  taskInfoCommentsAttachTag ({ commit, state }) {
    if (state.messageArea.attachment.tagTooltip.text) {
      commit('ATTACH_TASK_INFO_COMMENTS_TAG')
      commit('CLOSE_TASK_INFO_COMMENTS_TAG_TOOLTIP')
    } else {
      commit('SET_TASK_INFO_COMMENTS_TAG_VALID', { type: 'error', message: 'Поле не заполнено' })
    }
  },
  taskInfoCommentsRemoveTag ({ commit }, index) {
    commit('REMOVE_TASK_INFO_COMMENTS_TAG', index)
  },
  taskInfoCommentsClearValidation ({ commit }) {
    commit('CLEAR_TASK_INFO_COMMENTS_VALID')
  },
  async taskInfoCommentsSendMessage ({ commit, state }) {
    /* updatedId устанавливается, когда приходит коммент для редактирования и нужно вместо POST отправить PUT */
    try {
      const data = {
        text: clearUserHtml(state.messageArea.message, false),
        tags: state.messageArea.attachment.tags
      }
      const formData = new FormData()
      const files = state.messageArea.attachment.files

      // создание нового коммента
      if (!state.messageArea.updatedId) {
        data.task_id = state.task.id
        data.destination_id = state.messageArea?.destination?.id || null
        data.quote = state.messageArea.destination.quote

        const response = await createItem('task-comments', data)
        console.log(response)
        if (files.length) {
          files.forEach(file => formData.append('files[]', file))

          const commentId = response.data.data.id
          await createItem(`task-comments/${commentId}/upload`, formData, configMultipart)
        }
      } else {
        const commentId = state.messageArea.updatedId
        await updateItem('task-comments', commentId, data)

        const newFiles = files.filter(file => !file.id)
        if (newFiles.length) {
          newFiles.forEach(file => formData.append('files[]', file))
          await createItem(`task-comments/${commentId}/upload`, formData, configMultipart)
        }

        const removeFiles = state.messageArea.attachment.filesToRemove
        if (removeFiles.length) {
          await axios.all(removeFiles.map(id => deleteItem('files', id)))
        }
      }

      commit('CLEAR_TASK_INFO_COMMENTS_MESSAGE_AREA')
      commit('CLOSE_TASK_INFO_COMMENTS_LINK_TOOLTIP')
      commit('CLOSE_TASK_INFO_COMMENTS_TAG_TOOLTIP')
      this.dispatch('getUpdatedCurrentTask')
    } catch (e) {
      console.log('ошибка отправки комментария:', e.response)
      commit('SET_TASK_INFO_COMMENTS_MESSAGE_AREA_VALIDATION', e.response.data.validation)
    }
  },
  taskInfoCommentsCancelUpdate ({ commit }) {
    commit('CLEAR_TASK_INFO_COMMENTS_MESSAGE_AREA')
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
